<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12 footer-copyright text-center">
                <p class="mb-0 footer-text">© {{ year }} <span style="color: #db1e49;">Radius Group</span> All Rights Reserved </p>
            </div>
        </div>
    </div>
</footer>